<template>
  <div class="main lh-15 c-666">
    <section class="banner bgs-cover p-fix w-100p t-0">
      <div class="crumb d-f jc-fs ai-c ff-asl in-pc">
        <nuxt-link class="c-fff" to="/">Home</nuxt-link><span class="c-fff"></span
        ><nuxt-link class="c-fff" to="/product">Product</nuxt-link><span class="c-fff"></span
        ><a class="c-fff ff-as fw-500">FJD Connect Farm Management Platform</a>
      </div>

      <div class="banner-content c-fff p-a">
        <div class="p-r ov-h">
          <h1 class="banner-title m-0 fw-500">FJD CONNECT</h1>
          <div class="banner-desc">FARM MANAGEMENT PLATFORM</div>
        </div>

        <a
          :href="link ? link : 'javascript:;'"
          target="_blank"
          class="jump-link banner-btn d-ib ta-c fs-20"
          @click="processLogin"
          >Login</a
        >
      </div>
    </section>
    <!-- banner:end -->
    <div class="content p-r z-3 bgc-fff">
      <div class="nav-anchor z-99 l-0 w-100p bgc-fff c-333">
        <div class="h-100p m-a d-f jc-sb ai-c fs-16">
          <strong class="d-f ai-c fs-20 fw-500"
            >FJD Connect Farm Management Platform<span
              class="in-h5 triangle-icon triangle-icon-fff bgs-cover bgp-c"
            ></span
          ></strong>
          <div class="d-f">
            <div class="nav-anchor-item d-f jc-sb ai-c">
              <a href="#overview">Overview</a>
              <a href="#feature">Features</a>
            </div>
            <nuxt-link class="dealer-free-quote-btn d-ib ta-c bgc-222 c-fff in-pc" to="/basicinfo" target="_blank"
              >Free Quote</nuxt-link
            >
          </div>
        </div>
      </div>
      <!-- nav-anchor:end -->
      <section class="area-1" id="overview">
        <div class="w-12r m-a">
          <h2 class="ta-c">YOUR GUIDER IN PRECISON AG</h2>
          <div class="desc ta-c fs-18">
            An easy-to-use coordination platform that aids farmers with decision-making in precision agriculture. <br />
            It connects FJD autosteering kits and synchronizes data for higher efficiency, yields, and revenues.
          </div>
          <div class="img-box m-a">
            <img
              class="lazy-image"
              v-lazy="require('@/assets/images/farm-management-system/area-1.png')"
              data-original=""
              alt="YOUR GUIDER IN PRECISON AG"
              width="100%"
              height="100%"
            />
          </div>
          <div class="d-f jc-sb ta-c area-1-icon reveal">
            <div>
              <img
                width="100%"
                height="100%"
                class="d-b m-a"
                alt="Farm Management"
                src="data:image/svg+xml,%3Csvg width='136' height='136' viewBox='0 0 136 136' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='%23262626' stroke-width='2' fill='none' fill-rule='evenodd'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 65.739L68 25l49 40.739'/%3E%3Cpath d='M29.426 57.382v43.363c0 3.454 2.8 6.255 6.255 6.255h64.638c3.455 0 6.255-2.8 6.255-6.255V57.382'/%3E%3Cpath d='M69.55 59.471h15.13v12.065c0 10.644-8.628 19.273-19.272 19.273H50.277V78.744c0-10.644 8.628-19.273 19.273-19.273z' stroke-linejoin='round'/%3E%3Cpath d='M50.277 90.809l1.454-4.251a25.19 25.19 0 0 1 19.397-16.64' stroke-linecap='round'/%3E%3C/g%3E%3C/svg%3E"
              />
              <span class="d-b">Farm <br />Management</span>
            </div>
            <div>
              <img
                width="100%"
                height="100%"
                class="d-b m-a"
                alt=" Field Management"
                src="data:image/svg+xml,%3Csvg width='136' height='136' viewBox='0 0 136 136' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='%23262626' stroke-linejoin='round' fill='none' fill-rule='evenodd'%3E%3Cpath d='M22 33.846v68.308A3.846 3.846 0 0 0 25.846 106h45.23a3.846 3.846 0 0 0 3.668-5.006L53.138 32.686A3.846 3.846 0 0 0 49.471 30H25.846A3.846 3.846 0 0 0 22 33.846z' stroke-width='2'/%3E%3Cpath d='M27.775 38.657v58.686c0 1.062.861 1.923 1.923 1.923h35.344a1.923 1.923 0 0 0 1.833-2.503L48.313 38.077a1.923 1.923 0 0 0-1.833-1.343H29.698a1.923 1.923 0 0 0-1.923 1.923z' stroke-linecap='round' stroke-dasharray='2.884615384615385,2.884615384615385'/%3E%3Cpath d='M107.527 60.158l-8.26-27.421A3.846 3.846 0 0 0 95.584 30h-30.84a3.846 3.846 0 0 0-3.669 5.001l8.635 27.422a3.846 3.846 0 0 0 3.669 2.69h30.465a3.846 3.846 0 0 0 3.683-4.955z' stroke-width='2'/%3E%3Cpath d='M101.15 57.586l-6.375-21.167a1.923 1.923 0 0 0-1.842-1.368H69.244a1.923 1.923 0 0 0-1.834 2.5l6.666 21.167c.252.8.994 1.345 1.834 1.345h23.399a1.923 1.923 0 0 0 1.841-2.477zM114.22 98.231l-6.376-21.166a1.923 1.923 0 0 0-1.841-1.369H82.314a1.923 1.923 0 0 0-1.834 2.5l6.665 21.167c.253.801.995 1.346 1.835 1.346h23.399a1.923 1.923 0 0 0 1.84-2.478z' stroke-linecap='round' stroke-dasharray='2.884615384615385,2.884615384615385'/%3E%3Cpath d='M120.507 101.045l-8.26-27.422a3.846 3.846 0 0 0-3.682-2.737h-30.84a3.846 3.846 0 0 0-3.67 5.001l8.636 27.422A3.846 3.846 0 0 0 86.36 106h30.465a3.846 3.846 0 0 0 3.682-4.955z' stroke-width='2'/%3E%3C/g%3E%3C/svg%3E"
              />
              <span class="d-b"
                >Field <br />
                Management</span
              >
            </div>
            <div>
              <img
                width="100%"
                height="100%"
                class="d-b m-a"
                alt=" AG Machinery Management"
                src="data:image/svg+xml,%3Csvg width='136' height='136' viewBox='0 0 136 136' xmlns='http://www.w3.org/2000/svg'%3E%3Cg transform='translate(22 27.5)' stroke='%23262626' stroke-width='2' fill='none' fill-rule='evenodd'%3E%3Ccircle cx='15' cy='64.5' r='15'/%3E%3Ccircle cx='72' cy='60.5' r='21'/%3E%3Ccircle cx='72' cy='60.5' r='7'/%3E%3Ccircle cx='15' cy='64.5' r='4'/%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M30.5 53.5h8V61H46M7.5 46.5l-6-19h13M15 17.5h7V33M23 27.5h16L49 0h32.5l6 27.5V38'/%3E%3Cpath stroke-linejoin='round' d='M55.5 7.5l-7 20H79l-4.5-20z'/%3E%3C/g%3E%3C/svg%3E"
              />
              <span class="d-b">AG Machinery <br />Management</span>
            </div>
            <div>
              <img
                width="100%"
                height="100%"
                class="d-b m-a"
                alt=" Implement Management"
                src="data:image/svg+xml,%3Csvg width='136' height='136' viewBox='0 0 136 136' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='%23262626' fill='none' fill-rule='evenodd'%3E%3Cpath d='M111.102 67.927A4.898 4.898 0 0 1 116 72.825v9.716l-.001.044.001 20.456a1.96 1.96 0 0 1-1.96 1.959h-4.808a1.96 1.96 0 0 1-1.96-1.96V87.44h-5.818v15.602A1.96 1.96 0 0 1 99.496 105h-4.809a1.96 1.96 0 0 1-1.959-1.96V87.44h-5.818v15.602A1.96 1.96 0 0 1 84.95 105h-4.808a1.96 1.96 0 0 1-1.96-1.96V87.44h-5.818v15.602A1.96 1.96 0 0 1 70.405 105h-4.808a1.96 1.96 0 0 1-1.96-1.96V87.44h-5.818v15.602A1.96 1.96 0 0 1 55.86 105H51.05a1.96 1.96 0 0 1-1.96-1.96V87.44h-5.818v15.602A1.96 1.96 0 0 1 41.315 105h-4.81a1.96 1.96 0 0 1-1.959-1.96V87.44h-5.818v15.602A1.96 1.96 0 0 1 26.768 105H21.96A1.96 1.96 0 0 1 20 103.04V72.826a4.898 4.898 0 0 1 4.898-4.898h86.204zM57.452 25h21.096a3.918 3.918 0 0 1 3.319 6.001l-5.742 9.15a.98.98 0 0 1-.83.459h-14.59a.98.98 0 0 1-.83-.46l-5.742-9.149A3.918 3.918 0 0 1 57.453 25z' stroke-width='2' stroke-linejoin='round'/%3E%3Cpath d='M68 36.22a3.422 3.422 0 0 0 3.429-3.415A3.422 3.422 0 0 0 68 29.39a3.422 3.422 0 0 0-3.429 3.415A3.422 3.422 0 0 0 68 36.22z' stroke-width='2'/%3E%3Cpath d='M56.245 36.22c-18.123 7.804-25.47 18.048-31.347 30.731M78.286 36.22c18.122 7.804 25.47 18.048 31.347 30.731' stroke-width='1.5' stroke-linecap='round' stroke-dasharray='3.918367346938775,4.408163265306122'/%3E%3Cpath d='M60.163 40.61c-6.123 2.137-10.354 6.186-13.866 11.817-2.748 4.405-5.435 9.879-5.726 15.5M74.857 40.61c6.123 2.137 10.355 6.186 13.867 11.817 2.747 4.405 5.434 9.879 5.725 15.5' stroke-linecap='round' stroke-linejoin='round' stroke-dasharray='2.938775510204081,2.938775510204081'/%3E%3C/g%3E%3C/svg%3E"
              />
              <span class="d-b"
                >Implement <br />
                Management</span
              >
            </div>
            <div>
              <img
                width="100%"
                height="100%"
                class="d-b m-a"
                alt="24/7 Weather Forecast"
                src="data:image/svg+xml,%3Csvg width='136' height='136' viewBox='0 0 136 136' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='%23262626' stroke-width='2' fill='none' fill-rule='evenodd'%3E%3Cpath d='M85.933 101.35a17.415 17.415 0 0 1-7.097 1.647l-.329.003H35.25c-10.449 0-18.94-8.38-19.122-18.785l-.003-.461c0-10.355 8.23-18.788 18.504-19.116 2.342-11.595 12.559-20.324 24.808-20.324 8.743 0 16.45 4.446 20.998 11.208M104.853 55.77c.222-.57.41-1.15.563-1.737 1.352-5.193 0-10.938-4.06-14.998-6.102-6.102-16.011-6.086-22.133.035-1.3 1.3-2.324 2.771-3.073 4.34M110.223 30.169l-4.434 4.433M90.318 21.08l-.008 4.695M119.312 50.073l-4.696.006M70.385 30.232l4.419 4.419' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cg transform='translate(86 58)'%3E%3Cpath d='M12.5 0A5.5 5.5 0 0 1 18 5.5v21.772A12.5 12.5 0 0 1 25 38.5C25 45.404 19.404 51 12.5 51S0 45.404 0 38.5a12.5 12.5 0 0 1 7-11.228V5.5A5.5 5.5 0 0 1 12.5 0z' stroke-linejoin='round'/%3E%3Ccircle cx='12.5' cy='38.5' r='4.5'/%3E%3Cpath stroke-linecap='round' d='M12.5 11v22'/%3E%3C/g%3E%3Cpath stroke-linecap='round' d='M71.5 61.5h15M71.5 68.5h15M71.5 75.5h15M71.5 82.5h15'/%3E%3C/g%3E%3C/svg%3E"
              />
              <span class="d-b"> 24/7 Weather <br />Forecast</span>
            </div>
          </div>
        </div>
      </section>
      <!-- area-1:end -->
      <section class="area-2">
        <div class="w-12r m-a">
          <h2 class="ta-c">Devices</h2>
          <div class="img-box">
            <img
              class="lazy-image"
              v-lazy="require('@/assets/images/farm-management-system/area-2.jpg')"
              width="100%"
              height="100%"
              alt="Devices"
            />
          </div>
          <div class="d-f area-2-content">
            <div class="reveal">
              <i
                ><img
                  src="data:image/svg+xml,%3Csvg width='48' height='48' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='%23262626' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5' fill='none' fill-rule='evenodd'%3E%3Cpath d='M11.4 16.8a5.4 5.4 0 1 0 0-10.8 5.4 5.4 0 0 0 0 10.8zM8.055 15.64A17.873 17.873 0 0 0 6.36 20.4M15.64 8.055A17.874 17.874 0 0 1 20.4 6.36M36.6 16.8a5.4 5.4 0 1 0 0-10.8 5.4 5.4 0 0 0 0 10.8zM32.36 8.055A17.874 17.874 0 0 0 27.6 6.36M39.945 15.64a17.871 17.871 0 0 1 1.695 4.76M36.6 42a5.4 5.4 0 1 0 0-10.8 5.4 5.4 0 0 0 0 10.8zM39.945 32.36a17.873 17.873 0 0 0 1.695-4.76M32.36 39.945a17.873 17.873 0 0 1-4.76 1.695M11.4 42a5.4 5.4 0 1 0 0-10.8 5.4 5.4 0 0 0 0 10.8zM15.64 39.945a17.873 17.873 0 0 0 4.76 1.695M8.055 32.36A17.875 17.875 0 0 1 6.36 27.6M24 29.4V18.6M18.6 24h10.8-10.8z'/%3E%3C/g%3E%3C/svg%3E"
                  width="100%"
                  height="100%"
                  alt="Interconnection"
              /></i>
              <strong>Interconnection</strong>
              <div class="line"></div>
              <div class="desc">
                Connect farms and equipment for synched tasks, boundaries, guidance lines, and more. So farming becomes
                an integrated effort.
              </div>
            </div>
            <div class="reveal">
              <i
                ><img
                  src="data:image/svg+xml,%3Csvg width='48' height='48' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='%23262626' stroke-linejoin='round' stroke-width='2.3' fill='none' fill-rule='evenodd'%3E%3Cpath d='M24.886 5L44.77 19.379 37.613 43H12.16L5 19.379z'/%3E%3Cpath stroke-linecap='round' d='M37.613 43l-6.363-7.238M12.159 43l6.363-7.238M5.386 19.5l8.591 2.69M44.386 19.5l-8.591 2.69M24.886 5v9.048'/%3E%3Cpath d='M24.886 14.048l5.461 4.135 5.448 4.007-4.545 13.572H18.522L13.977 22.19l5.448-4.007zM9.971 15.784L5 19.38l1.79 5.905M10.369 37.095L12.159 43h6.363M31.25 43h6.363l1.79-5.905M39.8 15.784l4.971 3.595-1.79 5.905M29.857 8.595L24.886 5l-4.972 3.595'/%3E%3C/g%3E%3C/svg%3E"
                  width="100%"
                  height="100%"
                  alt="Interconnection"
              /></i>
              <strong>Visualized Data</strong>
              <div class="line"></div>
              <div class="desc">
                Check the positions, status, and historical records of the autosteering kits FJD Connect anytime for
                insight-based decisions.
              </div>
            </div>
            <div class="reveal">
              <i
                ><img
                  src="data:image/svg+xml,%3Csvg width='48' height='48' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='none' d='M0 0h48v48H0z'/%3E%3Cg stroke-linecap='round' stroke='%23262626' stroke-width='2.5'%3E%3Cpath d='M28.449 37c0 3.313-2.39 6-5.34 6h-7.118c-2.948 0-5.339-2.687-5.339-6V23.42c0-3.313 2.39-6 5.34-6h7.118c2.949 0 5.339 2.687 5.339 6V26'/%3E%3Cpath d='M19.551 12c0-3.313 2.39-6 5.34-6h7.118c2.948 0 5.339 2.687 5.339 6v13.58c0 3.313-2.39 6-5.34 6H24.89c-2.949 0-5.339-2.687-5.339-6V23M6.505 12.006l2.904 2.907M3 19.274h4.107m6.658-10.776v4.11m27.73 24.298L38.59 34M45 29.639h-4.107m-6.658 10.776v-4.111'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
                  width="100%"
                  height="100%"
                  alt="Interconnection"
              /></i>
              <strong>Coordination</strong>
              <div class="line"></div>
              <div class="desc">
                Create and assign tasks to autosteering kits for coordinated and streamlined workflow.
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- area-2:end -->
      <section class="area-3 p-r" id="feature">
        <div class="w-12r m-a">
          <h2 class="ta-c">Fields</h2>
          <div class="area-3-content d-f jc-sb">
            <div class="img-box">
              <img
                class="lazy-image"
                v-lazy="require('@/assets/images/farm-management-system/area-3.jpg')"
                width="100%"
                height="100%"
                alt="Fields"
              />
            </div>
            <div class="right-text d-f fd-c jc-sb">
              <div class="reveal">
                <i
                  ><img
                    src="data:image/svg+xml,%3Csvg width='48' height='48' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='none' d='M0 0h48v48H0z'/%3E%3Cpath stroke='%23262626' stroke-width='2.5' stroke-linejoin='round' d='M33 6h9v9h-9zM6 6h9v9H6zM6 33h9v9H6z'/%3E%3Cpath stroke='%23262626' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round' d='M10.5 33V15M37.5 22.5V15M15 10.5h18M15 37.5h7.5M24.636 24.636l5.94 17.818a.51.51 0 0 0 .953.04l3.29-7.676 7.674-3.289a.51.51 0 0 0-.04-.954l-17.817-5.939z'/%3E%3C/g%3E%3C/svg%3E"
                    width="100%"
                    height="100%"
                    alt="Interconnection"
                /></i>
                <strong>Mapping</strong>
                <div class="line"></div>
                <div class="desc">
                  Map out your boundaries FJD Connect with clicks of your mouse and get the acreage in no time.
                </div>
              </div>
              <div class="reveal">
                <i
                  ><img
                    src="data:image/svg+xml,%3Csvg width='48' height='48' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='none' d='M0 0h48v48H0z'/%3E%3Cg stroke='%23262626' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5'%3E%3Cpath d='M41 25v11H13V8h21'/%3E%3Cpath d='M20.852 18.398L28.63 26l14.387-14.062M29 42H7V19'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
                    width="100%"
                    height="100%"
                    alt="Interconnection"
                /></i>
                <strong>Task Assignment</strong>
                <div class="line"></div>
                <div class="desc">
                  Bulk create and assign tasks to the autosteering kits and base decisions on historical costs.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- area-3:end -->
      <section class="area-4">
        <div class="w-12r m-a">
          <h2 class="ta-c">Farming</h2>
          <div class="area-4-content d-f jc-sb fd-r">
            <div class="img-box">
              <video
                x5-playsinline
                x5-video-player-type="h5"
                x-webkit-airplay="allow"
                playsinline
                webkit-playsinline
                autoplay
                muted
                loop
                src="//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/b04a4773387702305023992576/dI9e3qguUPMA.mp4"
                poster="https://1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/98493394387702304746829630/sampleSnapshot/sampleSnapshot_10_0.jpg"
              ></video>
            </div>
            <div class="left-text d-f fd-c jc-sb">
              <div class="reveal">
                <strong>Production</strong>
                <div>Make farming plans for the whole season and keep track of them in one place.</div>
              </div>
              <div class="reveal">
                <strong>Role Design</strong>
                <div>
                  Assign roles and distribute tasks to farmers or employees so they can record and access data relevant
                  to them
                </div>
              </div>
              <div class="reveal">
                <strong>Inventory</strong>
                <div>
                  Keep a log of inbound and oubound of seedlings, fertilizers, pesticides, harvested products and so on.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- area-4:end -->
      <section class="area-5">
        <div class="w-12r m-a">
          <h2 class="ta-c">Service</h2>
          <div class="area-5-content d-f jc-sb">
            <div class="img-box">
              <img
                class="lazy-image"
                v-lazy="require('@/assets/images/farm-management-system/area-5.png')"
                data-original=""
                width="100%"
                height="100%"
                alt="Service"
              />
            </div>
            <div class="d-f fd-c jc-sb right-text">
              <div class="reveal">
                <strong>Dashboard</strong>
                <div class="line"></div>
                <div class="desc">
                  Preset threshold values that trigger alerts when stocks run low, a task is being delayed, or an input
                  consumption may exceed your expectation when you’re creating a future task
                </div>
              </div>
              <div class="reveal">
                <strong>Climate</strong>
                <div class="line"></div>
                <div class="desc">7/24 meteorological watch and natural hazard alert.</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- area-4 -->
    </div>
  </div>
</template>

<script>
  import bannerScroll from '@/mixins/bannerScroll.js'
  import { countrys } from '@/constants'
  export default {
    mixins: [bannerScroll],
    data() {
      return {
        link: '',
        country: ''
      }
    },
    head() {
      return {
        title: 'FJD Connect',
        meta: [
          {
            hid: 'keywords',
            name: 'keywords',
            content: 'farm management software'
          },
          // hid is used as unique identifier. Do not use `vmid` for it as it will not work
          {
            hid: 'description',
            name: 'description',
            content:
              'FJD Connect is a smart agricultural platform, which provides informatization and smart management of farm production.'
          }
        ]
      }
    },
    created() {},
    mounted() {
      this.getCountryByIp()
    },
    methods: {
      async getCountryByIp() {
        const { data } = await this.$api.homeApi.getCountryByIp()
        if (!data) return
        this.country = data.trim()
      },
      processLogin() {
        const { europe, usa, other } = countrys
        if (europe.includes(this.country)) {
          this.link = 'https://connect-eu.fjdynamics.com'
        } else if (usa.includes(this.country)) {
          this.link = 'https://connect-na.fjdynamics.com'
        } else if (other.includes(this.country)) {
          this.link = 'https://connect-as.fjdynamics.com'
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  h2 {
    color: #333;
  }
  .area-1 .area-1-icon span,
  .area-2-content strong,
  .area-4 .left-text strong,
  .area-5 .right-text strong,
  .area-3 .right-text strong {
    color: #333;
  }
  .area-2-content strong,
  .area-4 .left-text strong,
  .area-5 .right-text strong,
  .area-3 .right-text strong {
    font-weight: 500;
  }

  @media screen and (min-width: 768px) {
    .fs-40 {
      font-size: 0.4rem;
    }
    .fs-20 {
      font-size: 0.2rem;
    }
    .fs-18 {
      font-size: 0.18rem;
    }
    .fs-16 {
      font-size: 0.16rem;
    }
    .pl-360 {
      padding-left: 3.6rem;
    }
    .pr-360 {
      padding-right: 3.6rem;
    }
    h2 {
      font-size: 0.48rem;
    }
    /* banner */
    .banner {
      height: 8rem;
      top: 0.76rem;
      background-image: url('@/assets/images/farm-management-system/banner.jpg');
    }
    .banner .crumb {
      padding-top: 0.34rem;
      padding-left: 0.66rem;
      font-size: 0.16rem;
      display: flex;
      align-items: center;
      line-height: 1;
    }
    .banner .crumb span {
      height: 0.13rem;
    }
    .banner .crumb a:hover {
      color: #fff;
    }
    .crumb a:last-child:hover {
      color: #fff;
      font-weight: 500;
    }

    .banner-content {
      // left: 1.4rem;
      // top: 2.06rem;
      // width: 80%;
      // left: 1.4rem;
      // width: 80%;
      // top: 50%;
      // transform: translateY(-50%);
      padding: 2.5rem 0 0 2rem;
    }
    .banner-title {
      font-size: 0.64rem;
      line-height: 1.1;
      margin-bottom: 0.16rem;
    }
    .banner-desc {
      font-size: 0.48rem;
    }
    .banner-btn {
      // margin-top: 0.32rem;
      // font-size: 0.24rem;
      // width: 1.65rem;
      // line-height: 0.52rem;
      // color: rgba(0, 0, 0, 0.85);
      // background: rgba(255, 255, 255, 0.65);
      // transition: background-color 0.3s linear;
      padding-left: 0.48rem;
      padding-right: 0.48rem;
      line-height: 0.48rem;
      // padding: 0 0.32rem;
      margin-top: 0.48rem;
      background-color: rgba(255, 255, 255, 0.65);
      font-size: 0.2rem;
      color: #000;
    }
    .banner-btn:hover {
      background: rgba(255, 255, 255, 0.75);
    }

    .content {
      margin-top: calc(8rem + 0.76rem);
    }

    /* nav-anchor */
    .nav-anchor {
      height: 0.56rem;
      top: 0.76rem;
      position: sticky;
      box-shadow: 0px 0.02rem 0.04rem 0px rgba(0, 0, 0, 0.1);
    }
    .nav-anchor > div {
      padding-left: 1.6rem;
      padding-right: 1.6rem;
    }
    .nav-anchor a {
      margin-left: 0.8rem;
    }
    .nav-anchor .nav-anchor-item a:hover {
      font-weight: 700;
    }
    .nav-anchor .dealer-free-quote-btn {
      width: 1.1rem;
      line-height: 0.34rem;
      transition: background-color 0.3s linear;
    }
    .nav-anchor .dealer-free-quote-btn:hover {
      color: #fff;
      background-color: rgba(34, 34, 34, 0.85);
    }

    /* area-1 */
    .area-1 {
      padding: 1rem 0 0.82rem;
      background-color: rgba(250, 250, 250, 1);
    }
    .area-1 .desc {
      margin: 0.32rem 0 0.42rem;
    }
    .area-1 .img-box {
      width: 8.96rem;
      height: 5.08rem;
      margin-bottom: 0.64rem;
    }
    .area-1 .area-1-icon img {
      width: 1rem;
      height: 1rem;
    }
    .area-1 .area-1-icon span {
      margin-top: 0.08rem;
      font-size: 0.2rem;
    }

    /* area-2 */
    .area-2 {
      padding: 1rem 0 0.74rem;
    }
    .area-2 .img-box {
      margin: 0.32rem 0;
      height: 6.75rem;
    }
    .area-2-content i {
      display: block;
      width: 0.48rem;
      height: 0.48rem;
    }
    .area-2-content > div {
      margin-left: 0.24rem;
      width: 3.84rem;
      flex: 0 0 auto;
    }
    .area-2-content > div:nth-of-type(1) {
      margin-left: 0;
    }
    .area-2-content strong {
      display: block;
      margin-top: 0.08rem;
      font-weight: 500;
      font-size: 0.28rem;
    }
    .area-2-content .line {
      height: 1px;
      background-color: rgba(38, 38, 38, 0.5);
      margin: 0.24rem 0 0.15rem;
    }
    .area-2-content .desc {
      font-size: 0.18rem;
    }

    /* area-3 */
    .area-3 {
      padding-top: 2.1rem;
      padding-bottom: 2.6rem;
      background-color: rgba(250, 250, 250, 1);
    }
    .area-3 h2 {
      margin-bottom: 0.32rem;
    }
    .area-3 .img-box {
      width: 8.96rem;
      height: 5.04rem;
    }
    .area-3 .right-text {
      width: 2.72rem;
    }
    .area-3 .right-text i {
      display: block;
      margin-bottom: 0.08rem;
      width: 0.48rem;
      height: 0.48rem;
    }
    .area-3 .right-text strong {
      font-size: 0.28rem;
      color: rgba(38, 38, 38, 1);
    }
    .area-3 .line {
      height: 1px;
      background-color: rgba(38, 38, 38, 0.5);
      margin: 0.24rem 0 0.15rem;
    }

    /* area-4 */
    .area-4 {
      padding-top: 1rem;
    }
    .area-4 h2 {
      margin-bottom: 0.32rem;
    }
    .area-4 .left-text {
      width: 5.32rem;
      padding: 0.76rem 0;
      background: #fafafa;
    }
    .area-4 .left-text > div {
      padding: 0 0.32rem;
      font-size: 0.18rem;
    }
    .area-4 .left-text strong {
      display: block;
      margin-bottom: 0.16rem;
      font-size: 0.28rem;
    }
    .area-4 .img-box {
      width: 6.68rem;
      height: 6.68rem;
      overflow: hidden;
    }
    .area-4 .img-box video {
      height: 100.5%;
      position: relative;
      top: -1px;
      left: -2px;
    }

    /* area-5 */
    .area-5 {
      padding: 1.4rem 0;
    }
    .area-5 h2 {
      margin-bottom: 0.32rem;
    }
    .area-5 .img-box {
      width: 8.96rem;
      height: 5.04rem;
    }
    .area-5 .right-text {
      width: 2.72rem;
      padding: 0.22rem 0 0.36rem;
    }
    .area-5 .right-text strong {
      font-size: 0.28rem;
    }
    .area-5 .line {
      height: 1px;
      background-color: rgba(38, 38, 38, 0.5);
      margin: 0.24rem 0 0.15rem;
    }
  }
</style>
